module.exports = __webpack_public_path__ + "img/emotion-txt.f75ce66c.jpg";